import React, { Component, createElement, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import FocusTrap from '@s/FocusTrap';
import { getInitialFocusSelector } from '../../../helpers/helpers';
import { selectEventNameFromListingConfig } from 'checkout/selectors/ui';
import { TranslationContext } from '@c/Translations';
import clsx from 'clsx';

class TicketPickerContainer extends Component {
    componentDidMount = () => {
        window.scrollTo(0,0);
    }

    getContent = (t) => {
        const parentElement = this.props.inline ? 'div' : 'dialog';

        const dialogProps = {
          "aria-modal": true,
          "tabIndex": "-1",
        }

        const className = clsx(
          'tickets-wrap',
          this.props.inline ? 'tickets--inline' : 'tickets--as-overlay',
          {
            'tickets-wrap--seating-chart': this.props.isSeatingChart,
          }
        )
      
        return createElement(parentElement, {
          className: `tickets--as-overlay ${className}`,
          "aria-label": t('checkout__tickets_for_event', { event_name: this.props.eventName }),
          ...(!this.props.inline ? dialogProps : {}),
        }, (
          <div className={clsx("tickets", this.props.inline && "tickets--no-animation")}>
            {this.props.children}
          </div>
        ))
    };

    render() {
        return(
          <TranslationContext.Consumer>
            {({ t }) => (
              <Fragment>
                {!this.props.focusTrap && this.getContent(t)}
                {this.props.focusTrap && (
                  <FocusTrap
                      active={true}
                      fallback = {'.tickets-wrap'}
                      focusTrapOptions={{
                          initialFocus: getInitialFocusSelector('.ticket-action__add-button, .collapsible__button'),
                      }}

                  >
                      {this.getContent(t)}
                  </FocusTrap>
                )}
              </Fragment>
            )}
          </TranslationContext.Consumer>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        eventName: selectEventNameFromListingConfig(state),
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

TicketPickerContainer.propTypes = {
    focusTrap: PropTypes.bool,
}

TicketPickerContainer.defaultProps = {
    focusTrap: true,
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketPickerContainer)
